const getters = {
  oneMenu: state => state.menu.oneMenu,
  twoMenu: state => state.menu.twoMenu,
  // 案件详情
  caseInfo: state => state.app.caseDetails.caseInfo || {},
  // 当事人
  party: state => state.app.caseDetails.party || {},
  // 证据
  evidences: state => state.app.caseDetails.evidences || {},
  // 问题
  questions: state => state.app.caseDetails.questions || {},
  // 其他文件
  submits: state => state.app.caseDetails.submits || [],
  // 答辩
  replys: state => state.app.caseDetails.replys || {},
  // 操作
  operates: state => state.app.caseDetails.operates || [],
  // 费用
  fees: state => state.app.caseDetails.fees || [],
  // 审核记录
  audits: state => state.app.caseDetails.audits || {},
  // 判决书
  judge: state => state.app.caseDetails.judge || {},
  // 仲裁通知
  letters: state => state.app.caseDetails.letters || {},
  // 审核结果
  powers: state => state.app.caseDetails.powers,
  // 管辖异议答辩
  powerReply: state => state.app.caseDetails.powersReply || [],
  // 身份
  partyType: state => state.app.caseDetails.partyType || '',
  // 反请求
  reverser: state => state.app.caseDetails.reverser && state.app.caseDetails.reverser[0],
  // 意见反馈表
  feedback: state => state.app.caseDetails.feedback || [],
  // 其他请求
  otherApply: state => state.app.caseDetails.otherApply || [],

  statusDic: state => state.app.statusDic,

  // user用户登录信息
  sessionId: state => state.user.sessionId,
  userName: state => state.user.userName,

};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js